<template>
  <div class="header">
    <div class="left">
      <a href="/"><img class="logo" :src="logo"/></a>
      <span class="title">{{ $t('headbar.title') }}</span>
    </div>
    <div class="right">
      <template v-for="(button, index) in buttons">
        <a :key="index" :href="button.href" :target="button.target || '_self'">
          <el-button v-bind="button" size="medium">{{ button.label }}</el-button>
        </a>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      buttons: [
        { prop: 'start', type: 'primary', label: this.$t('headbar.button.start.label'), href: '#starter' },
        { prop: 'login', type: 'primary', plain: true, label: this.$t('headbar.button.login.label'), href: 'http://cloud.uzoombox.com', target: '_blank' }
      ]
    }
  },
  computed: {
    logo: function() {
      return require('@/assets/logo.svg')
    }
  },
  methods: {}
}
</script>

<style scoped>
.header {
  --logo-width: 16rem;
  --logo-height: 4rem;
  --title-fontsize: 1.8rem;
  --user-fontsize: 1.6rem;

  padding: 0 2rem;
  border-bottom: 0.1rem solid #dfe6ec;

  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.header .left {
  width: 80%;
  height: 100%;

  display: flex;
  flex: row;
  align-items: center;
}
.header .right {
  width: 20%;
  height: 100%;
  padding-right: 1rem;

  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
}

.left .logo {
  width: var(--logo-width);
  height: var(--logo-height);
}
.left .title {
  font-size: var(--title-fontsize);
  margin-left: 1rem;
}

.right a {
  padding-right: 1rem;
}
</style>
